import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Link as RouterLink, Route } from "react-router-dom";
import Link from "@material-ui/core/Link";
import { useHistory, useLocation } from "react-router";
import { observer } from "mobx-react-lite";
import { Routes } from "../../routes/routes";
import { LoginPage } from "../../pages/LoginPage";
import { RegisterPage } from "../../pages/RegisterPage";
import { useStyles, StyledDivider } from "./Auth.styles";
import { authStore } from "../../mobx/stores/AuthStore/AuthStore";

export const Auth = observer(() => {
  const history = useHistory();
  const location = useLocation<{ from: any }>();
  const { login, isLogged } = authStore;
  const classes = useStyles();

  useEffect(() => {
    if (isLogged) {
      const { from } = location.state || { from: { pathname: "/" } };
      history.push(from);
    }
  }, [history, isLogged, location.state]);

  return (
    <Grid container justify={"center"} alignItems={"center"} className={classes.container}>
      <Grid className={classes.item} item>
        <Paper className={classes.wrapper} elevation={3}>
          <Grid container>
            {renderLoginLink()}
            <StyledDivider orientation="vertical" flexItem />
            {renderRegisterLink()}
          </Grid>
          <Grid container>
            <Route path={`/${Routes.login}`} render={renderLoginPage} />
            <Route path={`/${Routes.register}`} render={renderRegisterPage} />
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );

  function renderLoginLink() {
    return location.pathname === `/${Routes.register}` ? (
      <Link className={classes.link} to={`/${Routes.login}`} component={RouterLink}>
        ВХОД
      </Link>
    ) : (
      <span className={classes.activeLink}>ВХОД</span>
    );
  }

  function renderRegisterLink() {
    return location.pathname === `/${Routes.login}` ? (
      <Link className={classes.link} to={`/${Routes.register}`} component={RouterLink}>
        РЕГИСТРАЦИЯ
      </Link>
    ) : (
      <span className={classes.activeLink}>РЕГИСТРАЦИЯ</span>
    );
  }

  function renderLoginPage(props: any) {
    return <LoginPage {...props} onLogin={login} />;
  }

  function renderRegisterPage(props: any) {
    return <RegisterPage {...props} />;
  }
});
